import { getterTypes } from './types';

const getters = {
  [getterTypes.GET_CATEGORY]: (state) => state.catalog.category,
  [getterTypes.GET_ROL]: (state) => state.catalog.rol,
  [getterTypes.GET_TABLE_CONFIG]: (state) => state.result.tableConfig,
  [getterTypes.GET_CURRENT_FILTER]: (state) => state.currentFilter,
  [getterTypes.GET_EVENTS]: (state) => state.events,
};

export default getters;
